/** How to reach OTS support. Everything is optional so a host can show only what applies. */
export type OtsSupportContact = {
  /** As shown, e.g. "+1 (267) 857-8084". */
  phone?: string;
  /** Dialable form for the tel: link, e.g. "+12678578084". Derived from `phone` when omitted. */
  phoneDial?: string;
  email?: string;
};

export const otsSupportContact: OtsSupportContact = {
  phone: "+1 (267) 857-8084",
  phoneDial: "+12678578084",
  email: "support@oilfieldtrackingservices.com"
};

export const otsResourceUrls = {
  documentation: "https://docs.oilfieldtrackingservices.com",
  website: "https://oilfieldtrackingservices.com",
  /** Featurebase portal where customers post ideas, vote, and report bugs. */
  feedback: "https://oilfieldtrackingservices.featurebase.app"
} as const;

export const toTelHref = (contact: OtsSupportContact): string =>
  `tel:${contact.phoneDial ?? (contact.phone ?? "").replace(/[^\d+]/g, "")}`;
